import React, { useEffect, useState } from 'react';
import { Form, Input } from 'semantic-ui-react';
import CustomModal from 'src/components/configuracion/components/customModal';

const FavoriteRouteModal = ({ open, onClose, onSave, saving = false }) => {
  const [label, setLabel] = useState('');

  useEffect(() => {
    if (!open) {
      setLabel('');
    }
  }, [open]);

  const handleConfirm = () => {
    const trimmed = label.trim();
    if (!trimmed || saving) return;
    onSave(trimmed);
  };

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Añadir ruta favorita"
      size="tiny"
      classNameContent="scfo-modal-form-body"
      content={
        <Form>
          <Form.Field>
            <label htmlFor="favorite-route-label">Nombre de la ruta</label>
            <Input
              id="favorite-route-label"
              value={label}
              onChange={(_, { value }) => setLabel(value)}
              placeholder="Ej. Panel ventas"
              maxLength={80}
              autoFocus
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  handleConfirm();
                }
              }}
            />
          </Form.Field>
        </Form>
      }
      confirmLabel="Guardar"
      confirmDisabled={!label.trim() || saving}
      isLoading={saving}
      onConfirm={handleConfirm}
    />
  );
};

export default FavoriteRouteModal;
